import angular from 'angular';
import travelExpenseActualsComponent from './travel-expense-actuals.component';

let travelExpenseActualsModule = angular.module('travelExpenseActuals', [])
  .component('travelExpenseActuals', travelExpenseActualsComponent);

export default travelExpenseActualsModule;



// WEBPACK FOOTER //
// ./client/pages/expenses/travel-expense-actuals/travel-expense-actuals.js